// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"41cddec84b2c4137b941","883":"220c8bdda4823dbb6b0b"}[chunkId] + ".js";
};